<template>
  <section
    class="staking-calculator-container"
    v-if="calculatorPlans.length > 0"
  >
    <h2 class="text-center font-Regular-24 onPrimary--text">
      {{ $t("staking.calculator.title") }}
    </h2>
    <p class="text-center font-Light-16 gray2--text mt-2">
      {{ $t("staking.calculator.description") }}
    </p>
    <div class="staking-grid">
      <div class="staking-step-one">
        <span class="font-Regular-16 mt-5">{{
          $t("staking.calculator.step1")
        }}</span>
        <v-autocomplete
          class="my-autocomplete pt-5"
          filled
          return-object
          v-model="selectedStaking"
          background-color="gray9"
          color="primary"
          :items="calculatorPlans"
          item-text="description"
          item-value="id"
          :loading="isLoading"
        >
          <template v-slot:item="{ item }">
            <div
              class="d-flex align-center justify-space-between rounded-xl"
              style="width: 100%"
            >
              <img
                :src="item.coinDto.logoUrl"
                alt=""
                style="width: 25px;height: 25px"
              />
              <!--              <span>{{ item.coinDto.coinUnit }}</span>-->
              <span>{{ item.description }}</span>
            </div>
          </template>
          <template v-slot:append-item>
            <div v-intersect="endIntersect" />
          </template>
        </v-autocomplete>

        <v-text-field
          dir="ltr"
          @input="changeInputPrice"
          hide-details
          flat
          v-model="amount"
          class="u-input align-center"
        >
          <template v-slot:prepend>
            <span class="">{{
              $t("staking.calculator.participaterAmount")
            }}</span>
          </template>
          <template v-slot:append>
            <span class="gray2--text ps-3">{{
              selectedStaking.coinDto.coinUnit
            }}</span>
          </template>
        </v-text-field>
        <div
          class="my-2 d-flex align-center justify-space-between"
          v-if="isAuth"
        >
          <div>
            <span class="font-Medium-12 gray2--text"
              >{{ $t("staking.calculator.assetAmount") }}:
            </span>
            <span class="font-Medium-12 gray2--text"
              >{{ $thousandMask(availableAmount) }}
              {{ selectedStaking.coinDto.coinUnit }}</span
            >
          </div>
          <v-btn
            text
            :to="
              `/operations/transfer?from=${selectedStaking.coinDto.coinUnit}`
            "
          >
            <span class="primary--text font-Medium-12 pe-1">{{
              $t("exchange.balanceIncrease")
            }}</span
            ><v-icon clr="var(--v-primary-base)" size="18"
              >$plusAddWallet</v-icon
            >
          </v-btn>
        </div>
      </div>

      <div class="staking-arrow">
        <div class="arrow-icon">
          <v-icon clr="var(--v-primary-base)">$arrowLeft</v-icon>
        </div>
      </div>

      <div class="staking-step-two">
        <div class="step-two-header">
          <div
            class="refresh-icon"
            @click="resetAmount"
            style="cursor: pointer;"
          >
            <v-icon clr="var(--v-primary-base)">$rotateRefreshLoading</v-icon>
          </div>
          <span class="staking-label font-Regular-16">{{
            $t("staking.calculator.step2")
          }}</span>
        </div>

        <v-row
          class="staking-card mx-1"
          v-for="(item, index) in selectedStaking.detailDtoList"
          :key="index"
        >
          <v-col cols="12" md="3">
            <div class="staking-card-left">
              <img
                :src="selectedStaking.coinDto.logoUrl"
                alt="Ethereum"
                class="staking-card-image"
                style="width: 40px;height: 40px"
              />
              <div>
                <div class="d-flex align-center" style="gap: 4px">
                  <span class="onPrimary--text font-Regular-14">{{
                    selectedStaking.coinDto.displayName
                  }}</span>
                  <span class="gray2--text font-Regular-12"
                    >({{ selectedStaking.coinDto.coinUnit }})</span
                  >
                </div>

                <div class="staking-coin-details">
                  <span
                    class="staking-days font-Regular-14"
                    style="width: 70px;"
                    >{{ item.duration }}
                    {{ $t("staking.calculator.day") }}</span
                  >
                  <div class="staking-apr">
                    <span class="apr-percentage font-Medium-16"
                      >{{ item.activeAPY }}%</span
                    >
                    <span class="apr-label font-Light-14">APR</span>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3" align-self="end">
            <div class="staking-reward-box">
              <span class="font-Regular-14 gray2--text">
                {{ $t("staking.calculator.aproximateReward") }}
              </span>
              <div class="staking-reward-value">
                <span
                  class="font-Bold-16 ltr text-truncate"
                  style="max-width: 200px;"
                  >{{
                    $thousandMask(
                      item.profit || 0,
                      selectedStaking.coinDto.rewardScale
                    )
                  }}</span
                >
                <span class="font-Regular-14 gray2--text">{{
                  selectedStaking.coinDto.coinUnit
                }}</span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              :disabled="!item.canStake"
              color="primary"
              block
              class="font-Medium-14"
              @click="$router.push(`/staking/${item.planDetailId}`)"
            >
              {{
                item.canStake
                  ? $t("staking.calculator.attentStakingBtn")
                  : $t("common.registrationClosed")
              }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </section>
</template>

<script>
import $thousandMask from "@/mixins/thousandMask";
import { mapActions, mapGetters } from "vuex";
import { staking } from "@/store/types";
import StakingService from "@/services/modules/market/staking";
import withdrawService from "@/services/modules/market/withdraw";
import { authMixin } from "@/mixins/authMixin";
export default {
  mixins: [$thousandMask, authMixin],

  data() {
    return {
      selectedStaking: {},
      amount: 0,
      isLastPage: false,
      totalItems: 0,
      isLoading: false,
      availableAmount: "0",
      exponent: 0,
      payload: {
        pageNo: 1,
        pageSize: 20,
        AssetCompare: false
      }
    };
  },
  mounted() {
    this.getCalculatorPlans(false);
    if (Object.keys(this.selectedStaking).length > 0) {
      this.changeInputPrice();
    }
  },
  methods: {
    ...mapActions({
      setCalculatorPlans: staking.actions.SET_CALCULATOR_PLANS
    }),
    async fetchWalletBalance(token) {
      try {
        const { data } = await withdrawService.getWallet(token);
        const response = data.data;
        this.exponent = response.withdrawScale;

        this.availableAmount = this.$thousandMask(
          response.strBalance,
          response.withdrawScale
        );
      } catch (error) {
        console.error("Error fetching wallet:", error);
      }
    },
    endIntersect(isIntersecting) {
      if (isIntersecting && !this.isLastPage) {
        this.isLoading = true;
        this.payload.pageNo++;
        this.getCalculatorPlans(true);
      }
    },
    getCalculatorPlans(append = false) {
      const serviceMethod = this.isAuth
        ? StakingService.getAllPlans
        : StakingService.getPublicPlans;

      serviceMethod(this.payload)
        .then(res => {
          const plansRes = res.data.data.content;
          this.setCalculatorPlans({ payload: plansRes, append: append });
          if (!append) {
            this.selectedStaking = plansRes[0];
          }
          this.isLastPage = res.data.data.last;
          this.totalItems = res.data.data.totalElements;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changeInputPrice() {
      this.selectedStaking.detailDtoList = this.selectedStaking.detailDtoList.map(
        item => {
          const netAmount = this.amount
            ? this.amount * (1 - item.enterFee / 100)
            : null;
          const profit = netAmount
            ? (((netAmount * item.activeAPY) / 365) * item.duration) / 100
            : null;
          return {
            ...item,
            profit
          };
        }
      );
    },
    resetAmount() {
      this.amount = 0;
      this.changeInputPrice();
    }
  },
  computed: {
    ...mapGetters({
      calculatorPlans: staking.getters.GET_CALCULATOR_PLANS
    })
  },
  watch: {
    selectedStaking(val) {
      this.isAuth && this.fetchWalletBalance(val.coinDto.coinUnit);
    }
  }
};
</script>

<style lang="scss">
.staking-calculator-container {
  background: var(--v-gray10-base);
  padding: 24px;
  border-radius: 16px;
}

.staking-grid {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 32px;
  gap: 16px;
}

.staking-step-one {
  max-width: 311px;
  background: var(--v-gray8-base);
  padding: 12px;
  border-radius: 8px;
}

.u-input {
  width: 100%;
  background-color: var(--v-gray9-base);
  border-radius: 8px;
  padding: 14px;
  outline: none;
  .v-input__prepend-outer {
    width: 9rem;
  }
  .v-input__append-inner {
    align-self: auto !important;
  }
}

.staking-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 8.33%;
}

.arrow-icon {
  width: 36px;
  height: 36px;
  background: var(--v-gray5-base);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.staking-step-two {
  flex: 1 1 100%;
  max-width: 66.66%;
  background: var(--v-gray8-base);
  padding: 12px;
  border-radius: 8px;
}

.step-two-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon {
  width: 32px;
  height: 32px;
  background: var(--v-gray9-base);
  border-radius: 50%;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.staking-card {
  background: var(--v-gray10-base);
  margin-top: 24px;
  border-radius: 16px;
  //padding: 12px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 768px) {
  .staking-card {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    //padding: 12px 8px;
  }
}

@media (max-width: 1264px) {
  .staking-arrow {
    transform: rotate(-90deg);
    margin-inline: auto;
  }

  .staking-grid {
    flex-direction: column;
  }

  .staking-step-one {
    max-width: 100%;
  }

  .staking-step-two {
    max-width: 100%;
  }

  .staking-card-left {
    margin-inline: auto;
  }
}

.staking-card-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.staking-card-image {
  width: 38px;
  height: 38px;
}

.staking-coin-details {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.staking-days,
.staking-apr {
  background: var(--v-gray11-base);
  padding: 4px 16px;
  border-radius: 4px;
  font-size: 12px;
  color: var(--v-onPrimary-base);
}

.apr-percentage {
  color: var(--v-success-base);
  margin-right: 4px;
}

.apr-label {
  color: var(--v-onPrimary-base);
  font-size: 12px;
}

.staking-reward-box {
  background: var(--v-gray11-base);
  padding: 8px;
  border-radius: 8px;
  text-align: center;
  width: 172px;
}

.staking-reward-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 4px;
}

//auto complete

.v-autocomplete__content.v-menu__content .v-select-list {
  margin-top: 10px;
  border-radius: 12px !important;
}

.v-menu__content {
  overflow-y: auto;
}

.v-menu__content::-webkit-scrollbar {
  width: 0;
}

.v-menu__content::-webkit-scrollbar-thumb {
  border-radius: 10px;
}

.v-menu__content::-webkit-scrollbar-track {
  background: transparent;
}
</style>
